import type { ZLogicalOperator } from "./ZQueryBuilderTypes";

export const logicalOperator: Record<ZLogicalOperator, ZLogicalOperator> = {
  AND: "AND",
  OR: "OR",
};

export const defaultLogicalOperator: ZLogicalOperator = logicalOperator.AND;

export const logicalOperatorOptions: {
  value: ZLogicalOperator;
  label: string;
}[] = [
  { value: logicalOperator.AND, label: "AND" },
  { value: logicalOperator.OR, label: "OR" },
];
